import { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { ArrowLeftIcon, ClipboardIcon, BanknotesIcon } from '@heroicons/react/24/outline';
import { CheckIcon } from '@heroicons/react/24/solid';
import p2pIcon from '../assets/images/payment/p2p.png';
// import cryptoIcon from '../assets/images/crypto.svg';
// import cardsIcon from '../assets/images/cards.svg';
// import p2pIcon from '../assets/images/p2p.svg';
// import overdraftIcon from '../assets/images/overdraft.svg';
import img1 from '../assets/images/card1.png'; // для gold
import img2 from '../assets/images/card2.png'; // для silver
import img3 from '../assets/images/card3.png'; // для platinum
import img4 from '../assets/images/card4.png'; // для остальных

import Card from '../assets/images/payment/card.png';
import Crypto from '../assets/images/payment/crypto.png';

import btc from '../assets/images/payment/btc.svg';
import eth from '../assets/images/payment/eth.svg';
import usdt from '../assets/images/payment/usdt.svg';

import bankTransfer from '../assets/images/payment/transfer.png';
import { useTranslations } from '../hooks/useTranslations';

const WALLET_ADDRESSES = {
  'btc': 'bc1qy75kck9e8yje5nt47qftfjuns8xayf8se7d540',
  'eth': '0x382b1b19d37A31bb2464E4F0C23408C1cBf31E0b',
  'usdt-erc20-bep20': '0x382b1b19d37A31bb2464E4F0C23408C1cBf31E0b',
  'usdt-trc20': 'TJxmar1E6yX81AZDgG9Y4gVqV75QPVuzqB'
};

const BANK_ACCOUNTS = [
  {
    id: 'bank1',
    bankName: 'Home Credit Bank KZT',
    accountNumber: 'KZ92886A220120766635',
    accountType: 'KZT',
    accountHolder: 'ТОО Academy of Information Technologies (ИИН/БИН 241240008310)',
    currency: 'KZT',
    iinBin: '241240008310',
    address: '050059, Almaty city, Nursultan Nazarbayev Ave., 248',
    phone: '+7 (727) 244 54 84',
    email: 'info@homecredit.kz'
  },
  {
    id: 'bank2',
    bankName: 'Home Credit Bank USD',
    accountNumber: 'KZ16886A220120766936',
    accountType: 'USD',
    accountHolder: 'ТОО Academy of Information Technologies (ИИН/БИН 241240008310)',
    currency: 'USD',
    iinBin: '241240008310',
    address: '050059, Almaty city, Nursultan Nazarbayev Ave., 248',
    phone: '+7 (727) 244 54 84',
    email: 'info@homecredit.kz'
  }
];

const CRYPTO_OPTIONS = [
  { id: 'btc', name: 'Bitcoin (BTC)', icon: btc },
  { id: 'eth', name: 'Ethereum (ETH)', icon: eth },
  { id: 'usdt-erc20-bep20', name: 'USDT ERC20 / BEP20', icon: usdt },
  { id: 'usdt-trc20', name: 'USDT TRC20', icon: usdt }
];

function Payment() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [copiedWallet, setCopiedWallet] = useState(null);
  const [copiedBankInfo, setCopiedBankInfo] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isP2PLoading, setIsP2PLoading] = useState(false);
  const [isCardLoading, setIsCardLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [, setError] = useState(null);
  const { t } = useTranslations();

  const PAYMENT_METHODS = [
    {
      id: 'card',
      title: t('payment.card'),
      icon: Card,
      description: t('payment.cardDescription'),
      disabled: false
    },
    {
      id: 'crypto',
      title: t('payment.crypto'),
      icon: Crypto,
      description: t('payment.cryptoDescription'),
      disabled: false
    },
    {
      id: 'p2p',
      title: t('payment.p2p'),
      icon: p2pIcon,
      description: t('payment.p2pDescription'),
      disabled: false
    },
    {
      id: 'coinumm',
      title: t('payment.coinumm'),
      icon: 'https://coinumm.com/assets/img/logo/logo-full-black.svg',
      description: '',
      disabled: false
    },
    // {
    //   id: 'revoxpay',
    //   title: t('payment.revoxpay'),
    //   icon: 'https://revoxpay.io/public/frontend/logo.png',
    //   description: '',
    //   disabled: false
    // },
    {
      id: 'kingpay',
      title: t('payment.kingpay'),
      icon: 'https://static.vecteezy.com/system/resources/previews/007/165/330/non_2x/credit-card-icon-credit-card-icon-application-design-illustration-credit-card-symbol-for-icons-logo-applications-templates-businesses-or-websites-free-vector.jpg',
      description: t('payment.securePayment'),
      disabled: false
    },
    {
      id: 'bank-transfer',
      title: t('payment.bankTransfer'),
      icon: bankTransfer,
      description: t('payment.bankTransferDescription'),
      disabled: false
    },
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch("https://api.maxprofitacademy.com/user", {
          method: "GET",
          headers: {
            "token": JSON.parse(token)
          }
        });

        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const courseType = searchParams.get('course')?.toUpperCase();
  const price = searchParams.get('price');

  // Функция для определения изображения курса
  const getCourseImage = (type) => {
    switch (type) {
      case 'SILVER':
        return img1;
      case 'GOLD':
        return img2;
      case 'PLATINUM':
        return img3;
      case 'TOPUP':
      default:
        return img4;
    }
  };

  useEffect(() => {
    if (courseType && price) {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [courseType, price]);

  const handleBack = () => {
    if (selectedMethod) {
      setSelectedMethod(null);
    } else {
      setSearchParams({});
      setIsVisible(false);
    }
  };

  const copyToClipboard = async (text, cryptoId) => {
    try {
      // Современный метод
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        setCopiedWallet(cryptoId);
        setTimeout(() => setCopiedWallet(null), 2000);
        return;
      }

      // Fallback для старых браузеров и HTTP
      const textArea = document.createElement('textarea');
      textArea.value = text;
      
      // Делаем элемент невидимым
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      
      // Выделяем и копируем текст
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        setCopiedWallet(cryptoId);
        setTimeout(() => setCopiedWallet(null), 2000);
      } catch (err) {
        console.error('Fallback: Не удалось скопировать', err);
      }
      
      // Удаляем временный элемент
      document.body.removeChild(textArea);
    } catch (err) {
      console.error('Не удалось скопировать текст: ', err);
    }
  };

  const copyBankInfo = async (text, bankId) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        setCopiedBankInfo(bankId);
        setTimeout(() => setCopiedBankInfo(null), 2000);
        return;
      }

      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        setCopiedBankInfo(bankId);
        setTimeout(() => setCopiedBankInfo(null), 2000);
      } catch (err) {
        console.error('Fallback: Не удалось скопировать', err);
      }
      
      document.body.removeChild(textArea);
    } catch (err) {
      console.error('Не удалось скопировать текст: ', err);
    }
  };

  const handleStripePayment = async (e) => {
    e.preventDefault();
    if (!userData || !courseType) {
      setError(t('payment.insufficientData'));
      return;
    }

    setIsCardLoading(true);
    try {
      const hasPromotion = userData?.promotion === true;
      const response = await fetch('https://api.maxprofitacademy.com/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          course: courseType,
          userId: userData?.id || userData?.user_id,
          promotion: hasPromotion,
          // Временно принудительно включаем код, чтобы бэкенд использовал рабочие Stripe-товары.
          code: true
        })
      });

      const contentType = response.headers.get('content-type');
      
      // Если ответ JSON - парсим и берем url
      if (contentType && contentType.includes('application/json')) {
        const data = await response.json();
        if (data.url) {
          window.location.href = data.url;
          return;
        }
        if (!response.ok) {
          setError(data.message || t('payment.paymentCreationError'));
        }
      } 
      // Если редирект - используем response.url
      else if (response.redirected && response.url) {
        window.location.href = response.url;
        return;
      }
      // Если статус 303 - берем Location заголовок
      else if (response.status === 303) {
        const location = response.headers.get('Location');
        if (location) {
          window.location.href = location;
          return;
        }
      }
      
      if (!response.ok) {
        setError(t('payment.paymentCreationError'));
      }
    } catch (error) {
      console.error('Error:', error);
      setError(t('payment.serverError'));
    } finally {
      setIsCardLoading(false);
    }
  };

  const handleKingPayPayment = async () => {
    if (!userData || !courseType || !price) {
      setError(t('payment.insufficientData'));
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch('https://api.maxprofitacademy.com/create-payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: parseFloat(price),
          firstName: userData.username,
          lastName: userData.lastname,
          course: courseType,
          id: userData.user_id.toString(),
          email: userData.email
        })
      });

      const data = await response.json();
      console.log('Payment response:', data);

      if (response.ok && data.status === 200 && data.data?.url) {
        try {
          new URL(data.data.url);
          window.location.href = data.data.url;
        } catch (e) {
          console.error('Invalid URL:', data.data.url);
          setError(t('payment.invalidPaymentUrl'));
        }
      } else {
        console.error('Payment error:', data);
        setError(data.message || t('payment.paymentCreationError'));
      }
    } catch (err) {
      console.error('Server error:', err);
      setError(t('payment.serverError'));
    } finally {
      setIsLoading(false);
    }
  };

  const renderStripeForm = () => (
    <button
      onClick={handleStripePayment}
      className="w-full bg-primary text-black font-medium py-3 px-4 rounded-xl hover:bg-primary/90 transition-colors"
    >
      {t('payment.payWithStripe')}
    </button>
  );

  const renderCryptoPayment = () => (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {CRYPTO_OPTIONS.map((crypto) => (
          <div key={crypto.id} className="border rounded-xl p-4">
            <div className="flex items-center mb-4">
              <img src={crypto.icon} alt={crypto.name} className="w-8 h-8 mr-4" />
              <span className="font-medium">{crypto.name}</span>
            </div>

            <div className="flex flex-col space-y-2">
              {/* Адрес кошелька */}
              <div className="relative flex items-center bg-gray-50 rounded-lg p-3 break-all">
                <div className="flex-1 pr-10 text-sm md:text-base overflow-x-auto">
                  {WALLET_ADDRESSES[crypto.id]}
                </div>
                {/* Кнопка копирования - теперь абсолютно позиционирована */}
                <button
                  onClick={() => copyToClipboard(WALLET_ADDRESSES[crypto.id], crypto.id)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 
                            text-primary hover:text-primary/80 
                            active:scale-95 transition-transform"
                >
                  {copiedWallet === crypto.id ? (
                    <CheckIcon className="w-5 h-5" />
                  ) : (
                    <ClipboardIcon className="w-5 h-5" />
                  )}
                </button>
              </div>
            </div>

          </div>
        ))}
      </div>
    </div>
  );

  const renderBankTransfer = () => (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <BanknotesIcon className="h-6 w-6 text-blue-600" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">{t('payment.bankTransferInstructions')}</h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>{t('payment.bankTransferStep1')}</p>
              <p>{t('payment.bankTransferStep2')}</p>
              <p>{t('payment.bankTransferStep3')}</p>
              <p>{t('payment.bankTransferStep4')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 block md:hidden border border-blue-200 rounded-xl p-4 mb-6">
      ТОО Academy of Information Technologies (ИИН/БИН 241240008310)
      </div>

      <div className="grid grid-cols-1 gap-6">
        {BANK_ACCOUNTS.map((account) => (
          <div key={account.id} className="border rounded-xl p-6 bg-white">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{account.bankName}</h3>
                <p className="text-sm text-gray-600">{account.accountType}</p>
              </div>
              <div className="text-right md:block hidden">
                <p className="text-sm text-gray-600">{t('payment.accountHolder')}</p>
                <p className="font-medium text-gray-900">{account.accountHolder}</p>
              </div>
            </div>

            <div className="space-y-3">
              {/* Account Number */}
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div>
                  <p className="text-sm text-gray-600">{t('payment.accountNumber')}</p>
                  <p className="font-mono text-sm font-medium">{account.accountNumber}</p>
                </div>
                <button
                  onClick={() => copyBankInfo(account.accountNumber, `${account.id}-account`)}
                  className="ml-2 p-2 text-blue-600 hover:text-blue-800 transition-colors"
                >
                  {copiedBankInfo === `${account.id}-account` ? (
                    <CheckIcon className="w-5 h-5" />
                  ) : (
                    <ClipboardIcon className="w-5 h-5" />
                  )}
                </button>
              </div>


            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (location.pathname === '/checkout') return null;

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 bg-white overflow-y-auto">
      <div className="max-w-7xl mx-auto px-4 pb-12 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="py-6 flex items-center space-x-4">
          <button
            onClick={handleBack}
            className="flex items-center text-gray-600 hover:text-gray-900"
          >
            <ArrowLeftIcon className="h-5 w-5 mr-2" />
            <span>{t('payment.back')}</span>
          </button>
          <div className="text-black font-medium">{userData?.username} {userData?.lastname}</div>
        </div>

        {/* Course Info */}
        <div className="bg-gray-50 rounded-2xl p-6 mb-8">
          <div className="flex items-center md:justify-between md:flex-row flex-col">
            <div className="flex gap-6">
              <div>
                <div className="text-sm text-gray-600 mb-2">{t('payment.product')}</div>
                <div className="text-xl md:text-3xl font-bold">{courseType?.toUpperCase()}</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-2">{t('payment.amountToPay')}</div>
                <div className="text-xl md:text-3xl font-bold">${price}</div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <img
                src={getCourseImage(courseType)}
                alt={`${courseType} course`}
                className="w-24 h-24 object-contain"
              />
            </div>
          </div>
          {/* <div className="mt-4 text-sm text-gray-600">
            Научитесь работать с биржей, использовать базовые инструменты для
            прогнозирования стоимости и торговать самостоятельно с нуля.
          </div> */}
        </div>

        {/* Payment Methods */}
        <div>
          <h2 className="md:text-2xl text-lg font-bold mb-6">
            {selectedMethod === 'crypto' 
              ? t('payment.cryptoPayment')
              : t('payment.selectPaymentMethod')}
          </h2>
          
          <div className={`grid grid-cols-1 ${!selectedMethod ? 'md:grid-cols-3' : 'md:grid-cols-1'} gap-6`}>
            {!selectedMethod && PAYMENT_METHODS.map((method) => (
              method.id === 'card' ? (
                <button
                  key={method.id}
                  onClick={handleStripePayment}
                  disabled={isCardLoading}
                  className="w-full flex flex-col md:items-center p-6 rounded-2xl border border-gray-200 hover:border-primary/50 transition-all duration-200 disabled:opacity-50"
                >
                  <div className="flex-shrink-0 w-12 h-12 md:w-32 md:h-32 md:mb-4">
                    {isCardLoading ? (
                      <div className="animate-spin rounded-full h-full w-full border-b-2 border-primary"></div>
                    ) : (
                      <img src={method.icon} alt={method.title} className="w-full h-full object-contain" />
                    )}
                  </div>
                  <div className="text-left md:text-center">
                    <h3 className="font-medium text-gray-900">{method.title}</h3>
                    <p className="text-sm text-gray-500">{method.description}</p>
                  </div>
                </button>
              ) : (
                <button
                  key={method.id}
                  onClick={() => {
                    if (method.id === 'p2p') {
                      setIsP2PLoading(true);
                    } else if (method.id === 'coinumm') {
                      window.open('https://coinumm.com/en/one-page-order', '_blank');
                    } else if (method.id === 'revoxpay') {
                      window.open('https://revoxpay.io', '_blank');
                    } else if (method.id === 'kingpay') {
                      handleKingPayPayment();
                    } else if (method.id === 'bank-transfer') {
                      setSelectedMethod(method.id);
                    } else {
                      setSelectedMethod(method.id);
                    }
                  }}
                  className="w-full flex flex-col md:items-center p-6 rounded-2xl border border-gray-200 hover:border-primary/50 transition-all duration-200"
                  disabled={(method.id === 'p2p' && isP2PLoading) || (method.id === 'kingpay' && isLoading)}
                >
                  <div className="flex-shrink-0 w-12 h-12 md:w-32 md:h-32 md:mb-4">
                    {method.id === 'p2p' && isP2PLoading ? (
                      <div className="animate-spin rounded-full h-full w-full border-b-2 border-primary"></div>
                    ) : method.id === 'kingpay' && isLoading ? (
                      <div className="animate-spin rounded-full h-full w-full border-b-2 border-primary"></div>
                    ) : typeof method.icon === 'function' ? (
                      <method.icon className="w-full h-full text-gray-600" />
                    ) : (
                      <img src={method.icon} alt={method.title} className="w-full h-full object-contain" />
                    )}
                  </div>
                  <div className="text-left md:text-center">
                    <h3 className="font-medium text-gray-900">{method.title}</h3>
                    <p className="text-sm text-gray-500">{method.description}</p>
                  </div>
                </button>
              )
            ))}

            {selectedMethod === 'card' && renderStripeForm()}
            {selectedMethod === 'crypto' && renderCryptoPayment()}
            {selectedMethod === 'bank-transfer' && renderBankTransfer()}
            {selectedMethod === 'p2p' && (
              <div className="text-center text-gray-600">
                {t('payment.p2pContactManager')}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment; 